<template>
  <div class="el-section">
    <div
      class="emd-container _highlight_header _header_spaced _footer_spaced_sm"
    >
      <div class="emd-container__header">
        <h2 class="emd-text _size_section">
          {{ $t('recipients.details.list.info.title') }}
          <span style="font-weight: 400">{{ data.id }}</span>
        </h2>
        <div style="display: flex">
          <h2
            class="emd-text _size_section"
            style="margin-right: 5px"
          >
            {{ $t('recipients.details.list.info.status_list') }}
          </h2>
          <span
            class="emd-badge"
            v-bind:class="status"
          >
            {{ data.status_label }}
          </span>
        </div>
      </div>
      <div class="emd-table-responsive">
        <Table
          :fields="fields"
          :items="[data]"
        ></Table>
      </div>
    </div>
  </div>
</template>
<script>
import Table from '@/components/project/molecules/Table.vue'
import { statusClass } from '@/filters'
import { recipientType, recipientStatus } from '@/filters/recipients'

/* eslint-disable camelcase */
export class Info {
  constructor (
    name,
    document,
    email,
    description,
    type,
    id,
    status,
    site_url,
    company_name,
    trading_name,
    annual_revenue,
    founding_date,
    address,
    main_address,
    managing_partners,
    createdAt,
    updatedAt
  ) {
    this.name = name
    this.document = document
    this.email = email
    this.description = description
    this.type = type && recipientType(type)
    this.id = id
    this.status = recipientStatus(status)
    this.status_label = status
    this.site_url = site_url
    this.company_name = company_name
    this.trading_name = trading_name
    this.annual_revenue = annual_revenue
    this.founding_date = founding_date
    this.address = address
    this.main_address = main_address
    this.managing_partners = managing_partners
    this.createdAt = createdAt
    this.updatedAt = updatedAt
  }
}

export default {
  name: 'RecipientInfo',
  components: {
    Table
  },
  props: {
    data: new Info()
  },
  data () {
    return {
      fields: [
        {
          id: 'name',
          label: 'recipients.details.list.info.name',
          type: 'text'
        },
        {
          id: 'document',
          label: 'recipients.details.list.info.document',
          type: 'text'
        },
        {
          id: 'email',
          label: 'recipients.details.list.info.email',
          type: 'text'
        },
        {
          id: 'createdAt',
          label: 'recipients.details.list.info.created_at',
          type: 'date',
          format: 'date'
        },
        {
          id: 'updatedAt',
          label: 'recipients.details.list.info.updated_at',
          type: 'date',
          format: 'date'
        }
      ]
    }
  },
  computed: {
    status () {
      return statusClass(this.data.status_label)
    }
  }
}
</script>
